export const MALE = { id: 'male', label: 'Maschio' };
export const FEMALE = { id: 'female', label: 'Femmina' };
export const UNDETERMINED = { id: 'undetermined', label: 'Indeterminato' };
